import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
import transformProp from 'loankeeper-common/containers/transformProp'
import withLoadingState from 'loankeeper-common/containers/withLoadingState'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'
import isUndefined from 'lodash/isUndefined'
import get from 'lodash/get'
//@ts-ignore
import withLookups from 'shared/containers/withLookups'
//@ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
import { addEditClientNote } from '../../../../store/client'
//@ts-ignore
import DropdownField from 'shared/FormFields/DropdownField'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
import { actions as DetailsContainerActions } from '../../../DetailsContainer'
import { addNoteModalName, addNoteFormName, modalActionTypes } from '../../constants'
import { translateNotes, translateLKMessage } from '../../helpers'
import { openFileDetails } from '../../../FileDetails'
import { AddNoteModalProps } from '../../types'

const valueSelector = formValueSelector(addNoteFormName)

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  .comment-field {
    flex: 1;
    margin-top: 5px;

    div,
    textarea {
      opacity: 1 !important;
      height: 100%;
    }
  }
`

//@ts-ignore
@withLoadingState
@LKModalContainer(addNoteModalName)
@withLookups({
  type: 'sys',
  query: 'Client_NoteTypes as options',
})
//@ts-ignore
@transformProp('options', (options) =>
  options.map(({ ID, Title }) => ({
    value: ID,
    text: Title,
  })),
)
@withLivedata('OpenDayStatus.Open_Day as OpenDay')
//@ts-ignore
@connect(
  (state, { params: { mode }, options = [], selected }: AddNoteModalProps) => {
    let initialValues:
      | {
          active: number
          comment: string
          clientNoteType: number
          date: string
          FileID: number
        }
      | {
          active: number
          clientNoteType?: number
        }

    if (selected && mode !== modalActionTypes.ADD) {
      const { Active, TypeID, Comment, NDate, LFLID } = selected

      initialValues = {
        active: Active,
        comment: Comment,
        clientNoteType: TypeID,
        date: moment(NDate).format('DD.MM.YYYY'),
        FileID: LFLID,
      }
    } else {
      const defNoteType: number = get(options, '[0].value')

      initialValues = {
        active: 1,
      }

      if (!isUndefined(defNoteType)) {
        initialValues.clientNoteType = defNoteType
      }
    }

    return {
      initialValues,
      clientNoteType: valueSelector(state, 'clientNoteType'),
      FileID: valueSelector(state, 'FileID'),
    }
  },
  {
    openFileDetails,
  },
)
//@ts-ignore
@reduxForm({
  form: addNoteFormName,
  onSubmit: (
    {
      comment,
      clientNoteType,
      active,
      FileID,
    }: { comment: string; clientNoteType: number; active: string; FileID: number },
    dispatch,
    {
      params: { mode },
      ID,
      hash,
      onRefresh,
      OpenDay,
      startLoading,
      endLoading,
      linkedfiles,
      selected,
    }: AddNoteModalProps,
  ) => {
    startLoading()
    const Active = parseInt(active, 10) ? 1 : 2

    const formattedOpenDate = new LKDate(moment(OpenDay)).toString()

    let fileHash: string
    if (FileID) {
      fileHash = linkedfiles.find((lf) => lf.ID === FileID).HashSum_FileID_
    }

    if (mode === modalActionTypes.PREVIEW) {
      endLoading()
      dispatch(LKModalActions.close(addNoteModalName))
    } else {
      dispatch(
        addEditClientNote({
          ClientID: ID,
          HashSum_ClientID_: hash,
          ID: mode === modalActionTypes.EDIT ? selected.ID : undefined,
          Comment: comment,
          TypeID: clientNoteType,
          Active,
          OperDate: formattedOpenDate,
          FileID,
          HashSum_FileID_: fileHash,
        }),
      )
        .then((response: { type: string; payload: any; meta: any }) => {
          if (addEditClientNote.fulfilled.match(response)) {
            dispatch([
              LKModalActions.close(addNoteModalName),
              DetailsContainerActions.fetchPage({
                type: 'Client',
                ID,
                hash,
                page: 'notes',
              }),
            ])
            endLoading()
            onRefresh()
          }
        })
        .catch((error) => {
          endLoading()
          dispatch(LKModalActions.openError(translateLKMessage(error.Error.Message || error.Error.Text)))
        })
    }
  },
})
class AddNoteModal extends React.Component<AddNoteModalProps> {
  LinkedFiles: Array<{ ID: number | string; Title: string; content: React.ReactNode }>
  isDisabled: boolean
  constructor(props: AddNoteModalProps) {
    super(props)

    this.LinkedFiles = props.linkedfiles.map(({ ID, Title, TypeTitle }) => ({
      ID,
      Title,
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>{ID}</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>{TypeTitle}</div>
          <div>{Title.substring(0, 10)}</div>
        </div>
      ),
    }))

    this.LinkedFiles.unshift({
      ID: '',
      Title: '',
      content: (
        <div className="u-flex u-directionRow u-alignCenter">
          <div style={{ width: 50, minWidth: 50, paddingRight: 15, textAlign: 'right' }}>--</div>
          <div style={{ width: 350, minWidth: 300, paddingRight: 15, textAlign: 'left' }}>--</div>
          <div>--</div>
        </div>
      ),
    })

    this.isDisabled = props?.mode === modalActionTypes.PREVIEW
  }

  isValidFileExtension = () => {
    const { linkedfiles } = this.props

    if (this.props.FileID) {
      const file = linkedfiles.find((lf) => lf.ID === this.props.FileID)
      return file.Ext.toLowerCase() === 'jpg' || file.Ext.toLowerCase() === 'png' || file.Ext.toLowerCase() === 'pdf'
    }
    return false
  }

  viewFile = () => {
    if (this.props.FileID) {
      const file = this.props.linkedfiles.find((lf) => lf.ID === this.props.FileID)

      this.props.openFileDetails({ ID: file.ID, hash: file.HashSum_FileID_, type: file.Ext })
    }
  }

  render() {
    const {
      params: { mode },
      modalInstanceName,
      clientNoteType,
      options,
      handleSubmit,
      isLoading,
    } = this.props
    const isDisabled = mode === modalActionTypes.PREVIEW

    return (
      <>
        <LKModal
          name={modalInstanceName}
          heading={translateNotes('frm_client_notes_add_edit')}
          size="sm-1"
          footer={
            <LKModal.Footer
              sideActions={
                <LKButton alias="ok" onClick={handleSubmit} disabled={isLoading}>
                  {translateNotes('cmd_finish')}
                </LKButton>
              }
            />
          }
        >
          <Wrapper>
            <FormLayout labelFieldProportions="2:14" label={translateNotes('chk_active')} autoHeight>
              <FormField id="active" type="checkbox" name="active" disabled={isDisabled} />
            </FormLayout>
            <FormLayout labelFieldProportions="2:14" label={translateNotes('lbl_type')}>
              <DropdownField id="clientNoteType" name="clientNoteType" options={options} disabled={isDisabled} />
            </FormLayout>
            {clientNoteType === 3 && (
              <FormLayout labelFieldProportions="2:14" label={translateNotes('lbl_file_t')}>
                <div className="u-flex">
                  <div style={{ width: 'calc(100% - 33px)' }}>
                    <FormField
                      type="select"
                      name="FileID"
                      menuWidth={550}
                      disabled={isDisabled}
                      options={this.LinkedFiles}
                    />
                  </div>

                  <LKButton
                    alias="preview"
                    className="u-marginLeft-5"
                    onClick={this.viewFile}
                    disabled={!this.isValidFileExtension()}
                  />
                </div>
              </FormLayout>
            )}
            <div className="comment-field">
              <FormField id="comment" type="textarea" name="comment" flex disabled={isDisabled} />
            </div>
          </Wrapper>
        </LKModal>
      </>
    )
  }
}

export const openAddNoteModal = (mode = modalActionTypes.ADD) => LKModalActions.open({ name: addNoteModalName, mode })

export default AddNoteModal
